import { render, staticRenderFns } from "./BookingListDialog.vue?vue&type=template&id=3b66479b&scoped=true"
import script from "./BookingListDialog.vue?vue&type=script&lang=ts"
export * from "./BookingListDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66479b",
  null
  
)

export default component.exports